import { boldFont, textSize } from 'styles/helpers'

export default {
  infoText: {
    ...textSize(14, 17),
    marginBottom: 32,

    '& strong': {
      ...boldFont(),
    }
  }
}
